import { observer } from "mobx-react";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { lang } from "../../lang";
import { store } from "../../store";
import { ROUTE_TYPE } from "../../HelperSrc";
import ContactsIcon from "@mui/icons-material/Contacts";
import DatabaseIcon from "@mui/icons-material/Storage";
import FileDocumentBoxOutlineIcon from "@mui/icons-material/AssignmentOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import MuiIconDoubleArrow from "@mui/icons-material/DoubleArrow";

@observer
class SidebarBase extends React.Component<RouteComponentProps> {
    public sidebar = store.sidebar || "";

    public clickArrow = () => {
        const elementContainer = document.querySelector<HTMLElement>(".page_container");
        const elementViewMain = document.querySelector<HTMLElement>(".view_sidebar");
        const open = "open";

        if (elementContainer && elementViewMain) {
            elementContainer.classList.toggle(open);
            elementViewMain.classList.toggle(open);
            this.sidebar = this.sidebar === open ? "" : open;
        }

        store.setSidebar(this.sidebar);
    };

    public render() {
        return (
            <div className={`view_sidebar ${store.sidebar}`}>
                {(() => {
                    const html: JSX.Element[] = [];

                    if (store.user.is_superuser || store.user.is_support) {
                        html.push(
                            <div key={"admin"} className="admin">
                                <p className="text">
                                    <span className="label">- {lang.admin}</span>
                                </p>
                                <div
                                    className="icon_text"
                                    data-at_id="sidebar_admin_users"
                                    onClick={() => {
                                        this.props.history.push(ROUTE_TYPE.ADMIN);
                                    }}
                                >
                                    <ContactsIcon />
                                    <p>{lang.users}</p>
                                    <div className="description">{`${lang.admin} - ${lang.users}`}</div>
                                </div>

                                {(() => {
                                    const html: JSX.Element[] = [];

                                    if (store.user.is_superuser) {
                                        html.push(
                                            <>
                                                <div
                                                    className="icon_text"
                                                    data-at_id="sidebar_admin_databases"
                                                    onClick={() => {
                                                        this.props.history.push(ROUTE_TYPE.ADMIN_CLIENTS);
                                                    }}
                                                >
                                                    <DatabaseIcon />
                                                    <p>{lang.databases}</p>
                                                    <div className="description">{`${lang.admin} - ${lang.databases}`}</div>
                                                </div>
                                                <div
                                                    className="icon_text"
                                                    data-at_id="sidebar_logs"
                                                    onClick={() => {
                                                        this.props.history.push(ROUTE_TYPE.LOGS);
                                                    }}
                                                >
                                                    <FileDocumentBoxOutlineIcon />
                                                    <p>{lang.auditLogs}</p>
                                                    <div className="description">{`${lang.admin} - ${lang.auditLogs}`}</div>
                                                </div>
                                            </>
                                        );
                                    }

                                    return html;
                                })()}
                                <p className="text">
                                    - <span className="label">{lang.clients}</span>
                                </p>
                            </div>
                        );
                    } else {
                        html.push(
                            <p className="text">
                                <span className="label">- {lang.clients}</span>
                            </p>
                        );
                    }

                    return html;
                })()}
                <div
                    key={"clients"}
                    className="icon_text"
                    data-at_id="sidebar_clients"
                    onClick={() => {
                        this.props.history.push(ROUTE_TYPE.CLIENTS);
                    }}
                >
                    <PeopleOutlineIcon />
                    <p>{lang.clients}</p>
                    <div className="description">{`${lang.clients} - ${lang.clients}`}</div>
                </div>
                <MuiIconDoubleArrow className="arrow" data-at_id="sidebar_arrow" onClick={this.clickArrow} />
            </div>
        );
    }
}

const Sidebar = withRouter(SidebarBase);

export { Sidebar };
